var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'slds-scoped-notification',
    ( _obj = {}, _obj[("slds-scoped-notification_" + _vm.variant)] = _vm.variant !== 'base', _obj ),
    ( _obj$1 = {}, _obj$1[("slds-theme_" + _vm.theme)] = _vm.theme, _obj$1 ),
    'slds-media',
    'slds-media_center' ],attrs:{"role":"status"}},[(_vm.bcWithFigure)?_c('div',{staticClass:"slds-media__figure"},[_vm._t("icon",function(){return [(_vm.theme)?_c('slds-icon',{staticClass:"slds-icon_container",attrs:{"category":"utility","name":_vm.theme,"size":"small","color-variant":"base"}}):_c('slds-icon',{staticClass:"slds-icon_container",attrs:{"category":"utility","name":"info","size":"small"}})]})],2):_vm._e(),_c('div',{staticClass:"slds-media__body"},[_c('p',[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }